module.exports = __webpack_public_path__ + "static/Labatt-7428214b966737ea046bb9d2352fd8f4.jpg";